module.exports = __webpack_public_path__ + "static/media/nu.d1014a5b.webp";